import { Heading } from "@ariakit/react";
import {
  ExternalLink,
  IndieTabletopClubLogo,
  useCurrentUser,
} from "@indietabletop/appkit";
import { interactiveText } from "@indietabletop/appkit/common.css.ts";
import type { ReactNode } from "react";
import { Link } from "wouter";
import { hrefs } from "../../hrefs.ts";
import { Divider } from "../forms/Divider.tsx";
import { Emphasis } from "./Emphasis.tsx";
import { feature, features } from "./style.css.ts";

function Feature(props: { counter: number; heading: string; info: ReactNode }) {
  const { counter, heading, info } = props;

  return (
    <div className={feature.container}>
      <div className={feature.counter}>{counter}</div>
      <div>
        <div className={feature.heading}>{heading}</div>
        <p className={feature.info}>{info}</p>
      </div>
    </div>
  );
}

export function FeaturesOverview() {
  const currentUser = useCurrentUser();

  return (
    <div className={features.container}>
      <Heading className={features.heading}>What&apos;s included?</Heading>

      <div className={features.list}>
        <Feature
          counter={1}
          heading="Space Gits PDF"
          info={
            <>
              The <Emphasis>Space Gits</Emphasis> rulebook in PDF format will be
              available for download inside the app immediately after purchase.
            </>
          }
        />
        <Feature
          counter={2}
          heading="In-app Rules Visibility"
          info={
            <>
              The visibility of all <Emphasis>core rules references</Emphasis>{" "}
              in the app will be unlocked. Bye bye squiggles!
            </>
          }
        />
      </div>

      <div className={features.divider}>
        <Divider />
      </div>

      <p className={features.accountInfo}>
        An Indie Tabletop Club account is needed to unlock in-app features and
        allow for easy downloads.{" "}
        {currentUser ? (
          <>
            Your current account (<em>{currentUser.email}</em>) will be used.
          </>
        ) : (
          <>
            <Link
              className={interactiveText}
              href={hrefs.login({
                redirectTo: hrefs.buy({ note: "backToIt" }),
              })}
            >
              Log in
            </Link>
            {" or "}
            <Link
              className={interactiveText}
              href={hrefs.join({
                redirectTo: hrefs.buy({ note: "backToIt" }),
              })}
            >
              create a new account
            </Link>
            {" now."}
          </>
        )}
      </p>

      <ExternalLink
        style={{ display: "contents" }}
        href={hrefs.itc({ content: "spacegits_features" })}
      >
        <IndieTabletopClubLogo className={features.itcLogo} />
      </ExternalLink>
    </div>
  );
}
